import {getXPathForField} from "../../utils/xpath_minimizer";
import {Field, Fields} from "../fields";


function canExtendElementXPath(elem: HTMLElement) {
    const xpath = getXPathForField(elem, true, false, null, null);

    const xpathParts = xpath.split("/");
    for (const part of xpathParts) {
        if (part.search(/\[\d+]/) >= 0) {
            return true;
        }
    }

    return false;
}

function extendElementXPath(xpath: string): string {
    const xpathParts = xpath.split("/");
    xpathParts.reverse();

    const newParts = [];
    let extended = false;
    for (const part of xpathParts) {
        if (!extended && part.search(/\[\d+]/) >= 0) {
            newParts.push(part.replace(/\[\d+]/, ""));
            extended = true;
        } else {
            newParts.push(part);
        }
    }

    newParts.reverse();
    return newParts.join("/");
}

function extendField(newModel: Fields, field: Field, elem: HTMLElement): Field {
    const elemXPath = field.getCorrespondingXPath(elem)
    if (!elemXPath) {
        return new Field(newModel, field.name, field.type, field.xpath_list)
    }

    const newXPathList = new Set(field.xpath_list);
    newXPathList.delete(elemXPath);
    newXPathList.add(extendElementXPath(elemXPath))

    return new Field(newModel, field.name, field.type, newXPathList);
}


function extendModel(model: Fields, elem: HTMLElement): Fields {
    const newModel = new Fields(model.document, model.blockXPath);
    for (const field of model.fields.values()) {
        const newField = extendField(newModel, field, elem);
        newModel.fields.set(field.name, newField);
    }

    return newModel;
}

export default {
    extendModel,
    canExtendElementXPath,
}
